<template>
    <!-- Stacked creator profiles - Single Dialog with multiple content layers -->
    <Dialog
        v-if="hasStackedCreators"
        :open="true"
        @update:open="onModalClose"
    >
        <DialogScrollContent class="w-full md:max-w-5xl border-none p-0 !bg-transparent !shadow-none !border-none">
            <DialogStack
                :active-index="creatorStack.length - 1"
                :total-dialogs="creatorStack.length"
            >
                <template #default="{ getDialogStyle, getContentStyle }">
                    <div
                        v-for="(profile, index) in creatorStack"
                        :key="`creator-${profile.platformId}-${profile.platformUserId}-${index}`"
                        class="dialog-stack-item w-full md:max-w-5xl rounded-lg bg-background shadow-2xl"
                        :style="getDialogStyle(index)"
                    >
                        <div :style="getContentStyle(index)" class="w-full h-full overflow-x-hidden">
                            <CreatorProfile v-bind="profile" />
                        </div>
                    </div>
                </template>
            </DialogStack>
        </DialogScrollContent>
    </Dialog>

    <!-- Backwards compatibility: single modal if not using stack -->
    <Dialog v-if="!hasStackedCreators && modals.creator.is_open" :open="modals.creator.is_open" @update:open="onCreatorProfileModalClose">
        <DialogScrollContent :class="'max-w-5xl border-none p-0'">
            <CreatorProfile
                :platform-id="modals.creator.platform_id"
                :platform-user-id="modals.creator.platform_user_id"
                :supercampaign-id="modals.creator.supercampaign_id"
                :campaign-id="modals.creator.campaign_id"
                :participant-id="modals.creator.participant_id"
                :participant="modals.creator.participant"
                :campaign="modals.creator.campaign"
                :is-limited-mode="modals.creator.is_limited_mode"
                :is-in-workflow="modals.creator.is_in_workflow"
                :targeting-groups="modals.creator.targetingGroups"
            />
        </DialogScrollContent>
    </Dialog>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import { Dialog, DialogScrollContent, DialogStack } from '@/components/ui/dialog'
import CreatorProfile from '@/partials/profiles/CreatorProfile/CreatorProfile.vue'

export default {
    components: {
        // eslint-disable-next-line
        Dialog,
        DialogScrollContent,
        DialogStack,
        CreatorProfile,
    },

    data() {
        return {}
    },

    computed: {
        ...mapGetters(['modals', 'creatorStack', 'hasStackedCreators']),
    },

    watch: {},

    methods: {
        onModalClose() {
            // Remove query params only when closing the last modal
            if (this.creatorStack.length === 1) {
                this.$router.push({
                    query: _(this.$route.query)
                        .omit(['modal', 'platform_id', 'platform_user_id'])
                        .omitBy((value, key) => key.startsWith('profile'))
                        .value(),
                })
            }

            this.$store.commit('modal:popFromStack')
        },

        onCreatorProfileModalClose() {
            this.$router.push({
                query: _(this.$route.query)
                    .omit(['modal', 'platform_id', 'platform_user_id'])
                    .omitBy((value, key) => key.startsWith('profile'))
                    .value(),
            })

            this.$store.commit('modal:close', 'creator')
        },

        onInteractOutside(event) {
            console.log('onInteractOutside', event)
        },
    },
}
</script>
